import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { LoginForm } from '../components/LoginForm';

export const Login = () => {
  const navigate = useNavigate();

  return (
    <Layout
      title="Welcome to Verdens Design Group"
      caption="Sign in to order designs or submit your project requests"
    >
      <LoginForm onSuccess={() => navigate('/')} />
    </Layout>
  );
};
